export const SETTING_TEMP = {
    AVAILABLES_USER: [
        'BMURGA',
        'BMURGAOE',
        'BMURGASPSA',
        'JCHAVEZ26',
        'PROJCHAVEZ26',
        'PROADMIN',
        'SPSAQAJCHAVEZ26',
        'OEQAJCHAVEZ26',
        'OEQAATORRES83',
        'PROQAJCHAVEZ26',
        'SPSAJCHAVEZ26',
        'OEADMIN',
        'SPSAADMIN',
        'PROPSANTIBANEZ'
    ]
};
